import { createContext, useState } from 'react'

import {
  IOrderProductionResponse,
  IOrderProductionsStatisticsResponse,
  OrderProductionStatus,
} from '../../sdk/order-production/order-production.types'
import { sdk } from '../../services/sdk'

interface OrderProductionsDataContext {
  orderProductionStatistics?: IOrderProductionsStatisticsResponse
  orderProductions: IOrderProductionResponse[]
  totalCount: number

  actions: {
    fetchOrderProductionStatistics: () => Promise<void>
    fetchOrderProductions: (
      page?: number,
      limit?: number,
      status?: OrderProductionStatus,
      code?: string,
    ) => Promise<void>
  }
}

interface OrderProductionsProviderProps {
  children: React.ReactNode
}

export const OrderProductionsContext = createContext(
  {} as OrderProductionsDataContext,
)

export function OrderProductionsProvider(props: OrderProductionsProviderProps) {
  const [orderProductionStatistics, setOrderProductionStatistics] =
    useState<IOrderProductionsStatisticsResponse>()
  const [orderProductions, setOrderProductions] = useState<
    IOrderProductionResponse[]
  >([])
  const [totalCount, setTotalCount] = useState(0)

  const fetchOrderProductionStatistics = async () => {
    const _response = await sdk.orderProduction.getOrderProductionsStatistics()
    setOrderProductionStatistics(_response)
  }

  const fetchOrderProductions = async (
    page = 1,
    limit = 10,
    status?: OrderProductionStatus,
    code?: string,
  ) => {
    const _response = await sdk.orderProduction.getOrderProductions(
      page,
      limit,
      status,
      code,
    )

    setOrderProductions(_response.data)
    setTotalCount(_response.count)
  }

  return (
    <OrderProductionsContext.Provider
      value={{
        orderProductionStatistics,
        orderProductions,
        totalCount,

        actions: {
          fetchOrderProductionStatistics,
          fetchOrderProductions,
        },
      }}
    >
      {props.children}
    </OrderProductionsContext.Provider>
  )
}
